import React, { ComponentType, FC } from 'react';
import SwipeableViews, { SwipeableViewsProps } from 'react-swipeable-views';
import { autoPlay, WithAutoPlayProps } from 'react-swipeable-views-utils';

interface AutoPlaySwipeableViewsProps {
    children: React.ReactNode;
    index: number;
    onChangeIndex: (index: number) => void;
    enableMouseEvents: boolean;
    interval?: number;
}

const AutoPlaySwipeableViews: FC<AutoPlaySwipeableViewsProps> = ({ children, index, onChangeIndex, enableMouseEvents, interval=6000 }) => {
    const SwipeableViewsWithAutoPlay = autoPlay(SwipeableViews) as ComponentType<SwipeableViewsProps & WithAutoPlayProps>;
    return <SwipeableViewsWithAutoPlay
        index={index}
        onChangeIndex={onChangeIndex}
        enableMouseEvents={enableMouseEvents}
        interval={interval}
    >
        {children}
    </SwipeableViewsWithAutoPlay>
}

export default AutoPlaySwipeableViews;